// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbody.v-tour--active{pointer-events:none\n}\n.v-tour{pointer-events:auto\n}\n.v-tour__target--highlighted{box-shadow:0 0 0 4px rgba(0,0,0,.4);pointer-events:auto;z-index:9999\n}\n.v-tour__target--relative{position:relative\n}", ""]);
// Exports
module.exports = exports;
